import { useEffect } from "react";
import env from "../../config/env";

const GoogleDrivePickers = ({ files_send_to_parent }) => {
  const GDriveURL = `${env.GDriveURL}`;
  const openPicker = () => {
    const width = 700;
    const height = 600;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;
    const popup = window.open(
      GDriveURL,
      "Google Drive Picker",
      `popup=yes,width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no`,
    );

    if (!popup) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    const interval = setInterval(() => {
      if (popup.closed) {
        clearInterval(interval);
        console.log("Popup closed by user.");
      } else {
        try {
          // Send to popup origin instead of "*"
          const popupOrigin = new URL(GDriveURL).origin;
          popup.postMessage({ action: "openPicker" }, popupOrigin);
          clearInterval(interval); // Stop the interval after message is sent
        } catch (err) {
          console.error("Error posting message:", err);
        }
      }
    }, 500);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      // Validate by hostname so http/https of the same host both pass
      try {
        const allowedHost = new URL(GDriveURL).hostname;
        const eventHost = new URL(event.origin).hostname;
        if (eventHost !== allowedHost) return;
      } catch (err) {
        return;
      }

      if (event.data?.action === "filesSelected") {
        files_send_to_parent(event.data.files);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [files_send_to_parent, GDriveURL]);

  return (
    <div>
      <button
        onClick={openPicker}
        style={{ background: "none", border: "none" }}
        className="text-[14px]"
      >
        Connect Google Drive
      </button>
    </div>
  );
};

export default GoogleDrivePickers;
